<template>
    <div class="canvas">
        <div v-if="docType !== '7' && activeName !=='7'" class="tabTitle">
            <el-tabs v-model="activeName" type="card" @tab-click="handleTabClick">
                <el-tab-pane label="协会简介" name="1"></el-tab-pane>
                <el-tab-pane label="协会章程" name="2"></el-tab-pane>
                <el-tab-pane label="会长理事名单" name="3"></el-tab-pane>
                <el-tab-pane label="组织结构" name="4"></el-tab-pane>
                <el-tab-pane label="联系我们" name="5"></el-tab-pane>
                <el-tab-pane label="会员管理办法" name="6"></el-tab-pane>
            </el-tabs>
        </div>
        <div class="canvas-title">{{docInfo.doc_name}}</div>
        <el-row class="canvas-title-details">
            <el-col cols="12" class="details-ci">
                <img src="../../assets/images/eye.png" alt="">
                <span class="num-ci">浏览：{{docInfo.access_count}}次</span>
                <img src="../../assets/images/check-time.png" alt="">
                <span class="date">发布时间：{{docInfo.create_date}}</span>
            </el-col>
        </el-row>
        <!-- <div id="content" class="content"></div> -->
        <div v-html="con" class="text"></div>
        <!-- <BaiduMap v-if="activeName === '5' || activeName ==='5' "></BaiduMap> -->
        
        <el-divider></el-divider>
        <div v-if="docType === '7' || activeName ==='7'">
            <div v-if="files.length">
                <p>附件信息</p>
                <ul>
                    <li v-for="item in files" :key="item.attach_id" class="downFile">
                        <div @click="download(item)">
                        <span href="javascript:">{{item.attach_name}}</span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="mt-50"></div>
        
    </div>
</template>
<script>
import {
    getDocBaseInfoByTypeApi,
    updateDocBaseInfoCntApi
} from "@/api"
import { download } from "@/request/utils";
// import BaiduMap from '@/components/BaiduMap/BaiduMap'
export default {
    name: 'about-us-wrapper',
    components:{
        // BaiduMap
    },
    data () {
        return {
            list: [],
            docType:'',
            docInfo: {},
            files:[],
            activeName:'1',
            con:''
        }
    },
    watch: {
        $route: {
            handler: function(val){
                this.docType = val.query.tab
                this.activeName = this.docType
                this.getDocInfo({ docType: val.query.tab })
            }
        }
    },
    created(){
        this.docType = this.docType?this.docType:window.location.hash.split('?tab=')[1]
        this.activeName = this.docType?this.docType:window.location.hash.split('?tab=')[1]
        this.getDocInfo({ docType: this.docType })
    },
    methods: {
        async getDocInfo(param){
            if (document.getElementById('content')) {
                document.getElementById('content').innerHTML = ''
            }
            const { data } = await getDocBaseInfoByTypeApi(param)
            this.docInfo = data.docBase
            this.files = data.docAttachList
             
            this.con = data.docBase.doc_content.replace(/\<img/gi, '<img width="100%" ')

            //更新浏览次数
            updateDocBaseInfoCntApi({ doc_id: this.docInfo.doc_id })
        },
        handleTabClick(tab){
            console.log(Number(tab.index)+1);
            this.docType = Number(tab.index)+1
            this.getDocInfo({ docType: Number(tab.index)+1 })
        },
        download(item){ //下载文件
            const path = `${CONFIG.UPLOAD_CONFIG.URL}/file/DownloadFile/${item.attach_id}`;
            download(path, item.attach_name, item.attach_type);
        },
    }
}
</script>
  <style lang="scss" scoped>
  @import './XAbout.scss';
  </style>
